import "./Controls.css"

import { forwardRef, useEffect, useRef } from "react"
import "trix"

import useCombinedRefs from "web/hooks/behaviour/useCombinedRefs"
import { isObjectWithProperty } from "web/services/helpers"

import ControlContainer from "./ControlContainer"

function getValidInputValue(value) {
  if (isObjectWithProperty(value, "value")) {
    const innerValue = value.value
    if (typeof innerValue === "string") return innerValue
  }

  return ""
}

const LegacyRichTextInput = forwardRef((props, ref) => {
  const {
    name,
    value,
    format = null,
    placeholder = "",
    kind,
    error,
    onChange,
    onFocus,
    onBlur,
  } = props
  const trixRef = useRef()
  const innerRef = useRef()
  const inputRef = useCombinedRefs(ref, innerRef)
  const staticOnChange = useRef()
  staticOnChange.current = onChange

  useEffect(() => {
    const activeElement = document.activeElement

    activeElement && activeElement.focus && activeElement.focus()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    trixRef.current.addEventListener("trix-change", (event) => {
      const targetValue = inputRef.current.value
      const plainTextValue = event.target.editor.getDocument().toString()

      const newValue =
        targetValue === ""
          ? null
          : { value: targetValue, plainTextValue, kind, format }

      if (targetValue === "") {
        staticOnChange.current(null)
      } else {
        staticOnChange.current(newValue)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleFocus(e) {
    onFocus && onFocus(e)
  }

  function handleBlur(e) {
    onBlur && onBlur(e)
  }

  return (
    <ControlContainer {...props} errorCondition={!!error}>
      <input
        type="hidden"
        id="trix"
        ref={inputRef}
        data-testid={`form-input-${name}`}
        value={getValidInputValue(value)}
      />
      <div className="rich-text-editor prose max-h-none max-w-none border border-primary-4 p-px [&_.trix-button-group--file-tools]:hidden [&_.trix-button-row]:overflow-x-visible">
        <trix-editor
          input="trix"
          class="trix-content h-20 overflow-y-auto border-none bg-white"
          ref={trixRef}
          placeholder={placeholder}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>
    </ControlContainer>
  )
})

export default LegacyRichTextInput
